import React, { useEffect, useState } from "react";
import { getHtmlPage } from "../data/htmlPages";
import { extractHtmlFragment, rewriteHtmlContent } from "../utils/html";

export default function StaticHtmlPage({ fileName, selector = ".container-fluid.py-24", className = "" }) {
  const [markup, setMarkup] = useState("");

  useEffect(() => {
    let alive = true;

    async function load() {
      const rawHtml = await getHtmlPage(fileName);
      const fragment = extractHtmlFragment(rawHtml, selector);
      if (alive) {
        setMarkup(rewriteHtmlContent(fragment));
      }
    }

    load();

    return () => {
      alive = false;
    };
  }, [fileName, selector]);

  return <div className={className} dangerouslySetInnerHTML={{ __html: markup }} />;
}
